import { render, staticRenderFns } from "./TifOperacionesForm.vue?vue&type=template&id=2a0f1c64"
import script from "./TifOperacionesForm.vue?vue&type=script&lang=js"
export * from "./TifOperacionesForm.vue?vue&type=script&lang=js"
import style0 from "./TifOperacionesForm.vue?vue&type=style&index=0&id=2a0f1c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports